
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DataTableHeader } from 'vuetify';
import {
  BaseProfileDataInterface,
  ProfileRepositoryInterface,
} from '@/services/Users-profile/interfaces';
import EventAttendantRepository from '@/services/Calendar/EventAttendant';
import { EventAttendantInterface } from '@/services/Calendar/EventAttendant/Interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    PageHeader,
  },
  inject: [
    'eventAttendantRepository',
    'profileRepository',
  ],
})
export default class Manage extends Vue {
  private readonly eventAttendantRepository!: EventAttendantRepository;

  private attendants: EventAttendantInterface[] = [];

  private profileRepository!: ProfileRepositoryInterface;
  private usersMap: { [userId: string]: BaseProfileDataInterface } = {};

  private headers: DataTableHeader[] = [
    { text: 'User', value: 'fullName' },
    { text: 'Additional Info', value: 'additionalInfo' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];
  private search: string = '';
  private loading: boolean = false;

  public async mounted(): Promise<void> {
    this.loading = true;
    const usersIds: string[] = [];
    const attendants = await this.eventAttendantRepository.getAllAttendantsForEvent(Number(this.$route.params.eventId));
    attendants.forEach((attendant) => {
      usersIds.push(attendant.userId);
    });
    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(usersIds);
    profiles.forEach((profile) => {
      this.usersMap[profile.userId] = profile;
    });

    this.attendants = attendants.map((attendant) => ({
      ...attendant,
      fullName: this.usersMap[attendant.userId]?.firstName ?
        `${this.usersMap[attendant.userId]?.firstName} ${this.usersMap[attendant.userId]?.lastName}` : 'Unknown User',
    }));

    this.loading = false;
  }
}
